import React from 'react';

export const SidebarData = [
  {
    title: 'Dashboard',
    link: '/client',
  },
  {
    title: 'Classes',
    link: '/client/classes',
  },
  {
    title: 'Contact Us',
    link: '/contact',
  },
  {
    title: 'Logout',
    link: '#',
  },
];
